import type * as SentryTypes from '@sentry/types';

import { ReportException } from '../errors';
import { Logger } from '../logger';

const logger = Logger('exceptions');

/**
 * Sentry integration to extract options from the ReportException error class
 * and enrich the Sentry event with it.
 */
export function reportExceptionIntegration(): SentryTypes.IntegrationFnResult {
    return {
        name: 'ReportExceptionIntegration',
        setupOnce() {},
        processEvent(event, hint) {
            if (!event.exception) {
                return event;
            }

            logger.info('reporting exception to Sentry with event ID', event.event_id);

            if (!hint?.originalException || !(hint?.originalException instanceof ReportException)) {
                return event;
            }

            const { tags, extra, fingerprint, attachments } = hint.originalException.options;

            if (attachments) {
                hint.attachments = attachments.map((attachment) => ({
                    filename: attachment.name,
                    data: attachment.body,
                    contentType: attachment.type,
                }));
            }

            return {
                ...event,

                tags: {
                    ...(event.tags || {}),
                    ...(tags || {}),
                },
                extra: {
                    ...(event.extra || {}),
                    ...(extra || {}),
                },
                fingerprint: event.fingerprint ?? fingerprint ?? [],
            };
        },
    };
}
